export default {
  CREATE: { TITLE: `Create a time off request`, SUMMARY: `` },
  EDIT: {
    TITLE: `Edit a time off request`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `View a time off request`,
    SUMMARY: ``
  },
  VACATIONTYPEID: {
    LABEL: `Request type`,
    DESCRIPTION: ``
  },
  COMMENT: {
    LABEL: `Comment`,
    PLACEHOLDER: `Write a comment...`,
    DESCRIPTION: ``
  },
  START: { LABEL: `Start`, PLACEHOLDER: ``, DESCRIPTION: `` },
  END: { LABEL: `End`, PLACEHOLDER: ``, DESCRIPTION: `` },
  COMMENT_REQUIRED: `The comment field is mandatory.`,
  REQUEST_TYPE_ID_REQUIRED: `The request type selection is mandatory.`,
  START_REQUIRED: `The start date is mandatory.`,
  END_REQUIRED: `The end date is mandatory.`,
  SUBMIT: `Submit`,
  QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`,
  END_BEFORE_START: `The end date must be after start date.`,
  SET_PARTIAL_DAYS: `Partial dates`,
  SET_PARTIAL_DAYS_DESC: `Allow setting a start and end time, rather than full days.`,
  START_END_MUST_BE_DIFFERENT: `The start and end dates must be different.`,
  REQUEST_OVERLAPPING_ANOTHER: `The dates entered are overlapping an already existing timeOff request.`
}
